export * from './DetailsNotes.component';
